import { render, staticRenderFns } from "./ChangeRol.vue?vue&type=template&id=3cc4e4c4&"
import script from "./ChangeRol.vue?vue&type=script&lang=js&"
export * from "./ChangeRol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports